import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";

import { CSSVariable } from "../../utils/CSSVariable";

export const ProductReviewWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
}));

export const ProductReviewListSettingsWrapper = styled("div")(({ theme }) => ({
    width: "100%",
    display: "flex",
    gap: theme.spacing(1),
    flexDirection: "column",
    [theme.breakpoints.up("sm")]: {
        flexDirection: "row",
    },
}));

export const ProductReviewListFilterWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
    flex: 1,
}));

export const ProductReviewListSortWrapper = styled("div")({
    display: "flex",
});

export const ProductReviewRatingWrapper = styled("div")(({ theme }) => ({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("md")]: {
        gap: theme.spacing(8),
        flexDirection: "row",
    },
    [theme.breakpoints.up("sm")]: {
        gap: theme.spacing(5),
        flexDirection: "row",
    },
}));

export const ProductReviewRatingSection = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    [theme.breakpoints.up("sm")]: {
        padding: 0,
    },
    ["&[data-ref='rating-details']"]: {
        flex: 1,
    },
}));

export const ReviewRatingAverageWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
}));

export const ProductReviewListItemWrapper = styled("div")(({ theme }) => ({
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(2, 2, 0, 2),
    borderRadius: theme.roundness,
}));

export const ProductReviewListItemInnerWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    paddingBottom: theme.spacing(2),
}));

export const ProductReviewTitleWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(1),
    flexWrap: "wrap",
    alignItems: "center",
}));

export const ReviewRatingGrid = styled("div")(({ theme }) => ({
    display: "grid",
    gridTemplateColumns: "auto 1fr auto",
    gridTemplateRows: "repeat(auto, 1fr)",
    columnGap: theme.spacing(1),
    width: "100%",
    height: "100%",
    [theme.breakpoints.up("md")]: {
        width: "382px",
    },
}));

export const ReviewRatingGridItem = styled("div")({
    display: "flex",
    alignItems: "center",
});

export const ProgressBarContainer = styled("div")(({ theme }) => ({
    //no
    position: "relative",
    height: 9,
    flex: 1,
    backgroundColor: theme.palette.common.white,
    borderRadius: 24,
    overflow: "hidden",
}));

export const PROGRESS_BAR_FILL_PERCENTAGE_VARIABLE = new CSSVariable("--progress-bar-fill-percentage");

export const ProgressBarFill = styled("div")(({ theme }) => ({
    position: "absolute",
    left: 0,
    top: 0,
    height: 9,
    width: PROGRESS_BAR_FILL_PERCENTAGE_VARIABLE.reference,
    backgroundColor: theme.palette.primary.main,
    borderRadius: 24,
    transition: "width 1s ease-out",
}));

export const ProductReviewListWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
}));

export const ProductReviewPaginationContainer = styled("div")(({ theme }) => ({
    "&&& ul": {
        flexWrap: "nowrap",
        flexDirection: "row",
        justifyContent: "center",
        gap: theme.spacing(0),
        [theme.breakpoints.up("md")]: {
            justifyContent: "flex-start",
            gap: theme.spacing(0.5),
        },
    },
}));

export const RatingListWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
    alignItems: "center",
}));

export const RatingItem = styled("div")(({ theme }) => ({
    // mp
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    color: theme.palette.text.secondary,
    "&&[data-enabled='false']": {
        "& [data-ref='rating']": {
            color: theme.palette.text.disabled,
        },
        cursor: "not-allowed",
    },
    "&:hover": {
        cursor: "pointer",
    },
}));

export const StarIconWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    "& > svg": {
        fontSize: 16,
        strokeWidth: 1,
        stroke: theme.palette.primary.main,
    },
}));

export const ProductReviewSortSelect = styled(Select)(({ theme }) => ({
    flex: 1,
    [theme.breakpoints.up("sm")]: {
        fontSize: 12,
        width: "auto",
    },
    "& .MuiOutlinedInput-notchedOutline": {
        border: "none", // Remove the border
    },
    "& .MuiSelect-select": {
        display: "flex",
        alignItems: "center",
        backgroundColor: theme.palette.common.white,
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5),
    },
}));
